<template>
  <div class="modal-overlay">
    <div class="modal-content">
      <slot name="content"></slot>
      <CancelButton class="back-btn" @click="closeModal">閉じる</CancelButton>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, onMounted, onUnmounted, SetupContext } from "vue";
import CancelButton from "@/components/CancelButton.vue";

type Props = {
  imgSrc: String;
};

export default defineComponent({
  name: "Modal",
  components: {
    CancelButton,
  },
  emits: ["close"],
  setup(props: Props, context: SetupContext) {
    onMounted(() => {});

    onUnmounted(() => {});

    function closeModal() {
      context.emit("close");
    }

    return {
      closeModal,
    };
  },
});
</script>

<style scoped>
.modal-overlay {
  z-index: 1;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.2);
  display: flex;
  justify-content: center;
  overflow: scroll;
  padding: 5%;
}

.modal-content {
  z-index: 2;
  width: 60%;
  text-align: center;
}

.back-btn {
  margin: 2rem 0;
}
</style>
